import { render, staticRenderFns } from "./ResalesShippingCreate.vue?vue&type=template&id=0b9a8387"
import script from "./ResalesShippingCreate.vue?vue&type=script&lang=js"
export * from "./ResalesShippingCreate.vue?vue&type=script&lang=js"
import style0 from "./ResalesShippingCreate.vue?vue&type=style&index=0&id=0b9a8387&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports